function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  fill: "#DF103A",
  fillRule: "nonzero",
  cx: 13,
  cy: 13,
  r: 13
}), React.createElement("path", {
  d: "M13.703 7h3.243c.423 0 .81.24.996.62l1.328 2.708h-5.567V7zm-1.25 0v3.328H6.895l1.387-2.722A1.11 1.11 0 019.27 7h3.183zm0 3.89v2.063h1.25v-2.062h5.703v7.656a1.11 1.11 0 01-1.11 1.11H7.86a1.11 1.11 0 01-1.109-1.11V10.89h5.703z",
  fill: "#FFF"
}));

var SvgParcel = function SvgParcel(props) {
  return React.createElement("svg", _extends({
    width: 26,
    height: 26
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjZweCIgaGVpZ2h0PSIyNnB4IiB2aWV3Qm94PSIwIDAgMjYgMjYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDU1LjEgKDc4MTM2KSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4KICAgIDx0aXRsZT5QYXJjZWwgPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IlBhcmNlbC0iPgogICAgICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsIiBmaWxsPSIjREYxMDNBIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGN4PSIxMyIgY3k9IjEzIiByPSIxMyI+PC9jaXJjbGU+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMy43MDMxMjUsNyBMMTYuOTQ1ODMzOCw3IEMxNy4zNjkwODcyLDcgMTcuNzU1NDU5OCw3LjI0MDgzNDg1IDE3Ljk0MTg0ODMsNy42MjA4Mzg1OCBMMTkuMjY5NzQ4NiwxMC4zMjgxMjUgTDEzLjcwMzEyNSwxMC4zMjgxMjUgTDEzLjcwMzEyNSw3IFogTTEyLjQ1MzEyNSw3IEwxMi40NTMxMjUsMTAuMzI4MTI1IEw2Ljg5NTE1NjI1LDEwLjMyODEyNSBMOC4yODE2NDU5LDcuNjA1ODkwMjMgQzguNDcxMDA1MjUsNy4yMzQxMDE5NSA4Ljg1Mjk1NTExLDcgOS4yNzAxODgyNSw3IEwxMi40NTMxMjUsNyBaIE0xMi40NTMxMjUsMTAuODkwNjI1IEwxMi40NTMxMjUsMTIuOTUzMTI1IEwxMy43MDMxMjUsMTIuOTUzMTI1IEwxMy43MDMxMjUsMTAuODkwNjI1IEwxOS40MDYyNSwxMC44OTA2MjUgTDE5LjQwNjI1LDE4LjU0Njg3NSBDMTkuNDA2MjUsMTkuMTU5NTY1OSAxOC45MDk1NjU5LDE5LjY1NjI1IDE4LjI5Njg3NSwxOS42NTYyNSBMNy44NTkzNzUsMTkuNjU2MjUgQzcuMjQ2Njg0MTEsMTkuNjU2MjUgNi43NSwxOS4xNTk1NjU5IDYuNzUsMTguNTQ2ODc1IEw2Ljc1LDEwLjg5MDYyNSBMMTIuNDUzMTI1LDEwLjg5MDYyNSBaIiBpZD0icGF0aC0xIiBmaWxsPSIjRkZGRkZGIj48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";
export { SvgParcel as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ./src/components/lib/Icons/SystemIcon/svg/parcel.svg
// module id = 913
// module chunks = 0